//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      yzm:'',
      captcha:'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random(),
    }
  },
  mounted(){

  },
  methods: {
    changeYzm() {
      this.captcha = 'https://api.abeiyun.com/www/yzm.php?rnd='+Math.random()
    },
    submit() {
      let data = 'cmd=web_clear'+
        '&id='+ this.$route.params.id +
        '&img_yzm='+ this.yzm
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/clearnet.vue